/*
  Split a string into a multidimensional object
  Can set a value on the last level, default: null

*/
export function splitCoordinates(position) {
  const pos = position && typeof position === 'string' ? position.split('-') : [59.32421, 18.07144];
  return pos;
}
